<template>
  <footer>
    <p class="copyright">
      © Medica staff promotion Co.,Ltd. All rights reserved.
    </p>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/footer.scss';
</style>